import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import React from "react";

import ExtendedPageHeader from "../ExtendedPageHeader";

const useStyles = makeStyles(
  () => ({
    backArrow: {
      color: "#247CFF",
      cursor: "pointer",
      fontSize: 25,
      marginLeft: "none",
      marginRight: "10px",
      marginTop: "5px"
    }
  }),
  { name: "PageBackNavigation" }
);

interface PageBackNavigationProps {
  children?: React.ReactNode;
  className?: string;
  inline?: boolean;
  idAppHeader?: string;
  onBack();
}

const PageBackNavigation: React.FC<PageBackNavigationProps> = props => {
  const { children, className, inline, idAppHeader, onBack } = props;

  const classes = useStyles(props);

  return (
    <div onClick={onBack}>
      <ExtendedPageHeader className={className} inline={inline}>
        <ArrowBackIcon
          className={classes.backArrow}
          id={`${idAppHeader ? idAppHeader : "appHeaderBackBtn"}`}
        />
        <div>{children}</div>
      </ExtendedPageHeader>
    </div>
  );
};

PageBackNavigation.displayName = "PageBackNavigation";
export default PageBackNavigation;
